
import React from 'react'
import icon from './svgs/SquareAcademicCap2.svg'
import { BaseIcon } from './_base'

export const SquareAcademicCap2Icon = ({ size, fontSize, sx }) => {
    return (
        <BaseIcon icon={icon} {...{ fontSize, size, ...sx }} />
    )
}
